import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import AcAirCompressor from 'features/processFlowDiagrams/svg/compressors/ac-air-compressor.svg?react'
import CentrifugalCompressor from 'features/processFlowDiagrams/svg/compressors/centrifugal-compressor.svg?react'
import CentrifugalCompressorTurbineDriven from 'features/processFlowDiagrams/svg/compressors/centrifugal-compressor---turbine-driven.svg?react'
import Compressor from 'features/processFlowDiagrams/svg/compressors/compressor.svg?react'
import CompressorAndSilencers from 'features/processFlowDiagrams/svg/compressors/compressor-and-silencers.svg?react'
import LiquidRingCompressor from 'features/processFlowDiagrams/svg/compressors/liquid-ring-compressor.svg?react'
import ReciprocatingCompressor from 'features/processFlowDiagrams/svg/compressors/reciprocating-compressor.svg?react'
import ReciprocatingCompressor2 from 'features/processFlowDiagrams/svg/compressors/reciprocating-compressor-2.svg?react'
import RotaryCompressor from 'features/processFlowDiagrams/svg/compressors/rotary-compressor.svg?react'
import React from 'react'

export const PID_COMPRESSORS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'ac-air-compressor',
    name: 'AC Air Compressor',
    category: 'compressors',
    svgContent: <AcAirCompressor />,
    viewBox: '0 0 101 68',
  },
  {
    id: 'centrifugal-compressor',
    name: 'Centrifugal Compressor',
    category: 'compressors',
    svgContent: <CentrifugalCompressor />,
    viewBox: '0 0 70 67',
  },
  {
    id: 'centrifugal-compressor---turbine-driven',
    name: 'Centrifugal Compressor - Turbine Driven',
    category: 'compressors',
    svgContent: <CentrifugalCompressorTurbineDriven />,
    viewBox: '0 0 98 67',
  },
  {
    id: 'compressor',
    name: 'Compressor',
    category: 'compressors',
    svgContent: <Compressor />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-and-silencers',
    name: 'Compressor and Silencers',
    category: 'compressors',
    svgContent: <CompressorAndSilencers />,
    viewBox: '0 0 90 80',
  },
  {
    id: 'liquid-ring-compressor',
    name: 'Liquid Ring Compressor',
    category: 'compressors',
    svgContent: <LiquidRingCompressor />,
    viewBox: '0 0 90 90',
  },
  {
    id: 'reciprocating-compressor',
    name: 'Reciprocating Compressor',
    category: 'compressors',
    svgContent: <ReciprocatingCompressor />,
    viewBox: '0 0 98 40',
  },
  {
    id: 'reciprocating-compressor-2',
    name: 'Reciprocating Compressor 2',
    category: 'compressors',
    svgContent: <ReciprocatingCompressor2 />,
    viewBox: '0 0 50 65',
  },
  {
    id: 'rotary-compressor',
    name: 'Rotary Compressor',
    category: 'compressors',
    svgContent: <RotaryCompressor />,
    viewBox: '0 0 42 91',
  },
]
